import { useMemo } from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';

import { Typography, Link as MuiLink } from '@mui/material';

import { useTranslate } from 'src/locales';

export default function BreadcrumbLink({ match, location, crumb }) {
  const { i18nKey, text, disabled } = crumb;
  const { t } = useTranslate();
  const isEnd = useMemo(
    () => match?.pathname === location?.pathname,
    [location?.pathname, match?.pathname]
  );

  const textRender = useMemo(
    () => <Typography variant="body2">{i18nKey ? t(i18nKey) : text}</Typography>,
    [i18nKey, t, text]
  );

  if (isEnd || disabled) return <>{textRender}</>;
  return (
    <MuiLink component={Link} to={match.pathname} underline="always">
      {textRender}
    </MuiLink>
  );
}

BreadcrumbLink.propTypes = {
  match: PropTypes.object,
  location: PropTypes.object,
  crumb: PropTypes.object,
};
